export const buildEnquiryKpis = (rows = [], { totalOverride = null, serverCounts = null } = {}) => {
  const normalize = (value) => String(value || '').trim().toUpperCase();
  const stages = rows.map((r) => normalize(r.pipelineStage || r.status));

  const pendingPriceCount = stages.filter((s) => s === 'PENDING_PRICE' || s === 'FEASIBILITY').length;
  const quotedCount = stages.filter((s) => s.includes('QUOTE') || s === 'OFFER' || s === 'OFFER_SUBMITTED').length;
  const wonCount = stages.filter((s) => s.includes('WON') || s === 'ORDER_WON' || s === 'DEAL_WON').length;
  const total = Number.isFinite(totalOverride) ? totalOverride : rows.length;
  if (serverCounts) {
    return [
      { label: 'Total Enquiries', value: total },
      { label: 'Pending Price', value: serverCounts.pending_price ?? 0 },
      { label: 'Quoted', value: serverCounts.quoted ?? 0 },
      { label: 'Orders Received', value: serverCounts.orders_received ?? 0 },
      { label: 'Conversion Rate', value: `${serverCounts.conversion_rate ?? 0}%` },
    ];
  }
  const conversion = total > 0 ? `${Math.round((wonCount / total) * 100)}%` : '0%';

  return [
    { label: 'Total Enquiries', value: total },
    { label: 'Pending Price', value: pendingPriceCount },
    { label: 'Quoted', value: quotedCount },
    { label: 'Orders Received', value: wonCount },
    { label: 'Conversion Rate', value: conversion },
  ];
};
